const route = {
  workbench: 'Workbench',
  pointsRecord: 'Points Record',
  aiSourcingLab: 'AI Sourcing Lab',
  beta: 'Beta',
  reportCenter: 'Report Center',
  emailConfig: 'Senders',
  coldEmail: 'Cold Email',
  inbox: 'Inbox',
  contentManagement: 'Outreach',
  recruitingAi: 'Agent',
  recruitingAiV2: 'Agent',
  newRecruitingConversation: 'New Recruiting',
  recruitingSection: 'Recruiting',
  recruitingProjects: 'Recruiting Projects',
  recentConversations: 'Recent Conversations',
  platformSection: 'Platform',
  adminSection: 'Ops',
  resumeImportMonitor: 'Resume Import Liveboard',
  recommendationReportPreview: 'Recommendation Report Preview',
  allTalents: 'Data Summary',
  talentGroup: 'Talent Pool',
  jobsGroup: 'Project',
  jobList: 'Recruiting Projects',
  jobCreate: 'Create Job',
  jobCandidates: 'Job Candidates',
  resumeParse: 'Resume Parsing',
  candidateGroups: 'Group List',
  pricing: 'Membership',
  referral: 'Referral Rewards',
  referralInvite: 'Friend Invite',
  settingsProfile: 'Account Settings',
  adminOrganizations: 'Organization Management',
  organization: 'Organization & Seats',
}

export default route
